goog.provide('el8.appchart.dialog.ordermed.ignoreIntxnReason');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appchart.dialog.ordermed.ignoreIntxnReason');
goog.require('el8.appchart.dialog.ordermed.confirmPharmacyNote');


el8.appchart.dialog.ordermed.ignoreIntxnReason = (function() {

    var majorIntxns = null;
    var model = null;
    var saveCallbackFn = null;
    var hideCallbackFn = null;
    var hasPrescriptionNote = true;
    var defaultOverrideText = 'Over-ride Contra-indication & Prescribe';

    var that = new el8.uiwidget.FormDialog({
        title: "Reason for dismissing Major Interaction alert",
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appchart.dialog.ordermed.ignoreIntxnReason.content();
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'ignoreIntxnReason',
                type: 'input',
                selector: ':input[name="ignoreIntxnReason"]',
                height: 45,
                maxLength: 150,
                infoText: 'reason for prescribing medication that is contra-indicated...'
            },
            {
                name: 'addToPrescriptionNote',
                type: 'input',
                selector: ':input[name="addToPrescriptionNote"]',
                defaultVal: true
            }
        ]
    });

    form.addButton('save', defaultOverrideText, function(form) {
        var reason = form.getVal('ignoreIntxnReason');
        if (!reason) {
            el8.uiwidget.alert('A reason is required.');
        } else {
            if (form.getVal('addToPrescriptionNote')) {
                el8.appchart.dialog.ordermed.confirmPharmacyNote.show({
                    reason: reason,
                    model: model,
                    saveCallbackFn: function(pharmacyNote) {
                        if (saveCallbackFn) { saveCallbackFn(reason, pharmacyNote); }
                    },
                    hideCallbackFn: hideCallbackFn
                });
                that.hide();
            } else {
                if (saveCallbackFn) { saveCallbackFn(reason); }
                that.hide();
            }
        }
    }, true);
    form.addButton('cancel', 'Change Script', function(form) {
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        spec = spec || {};
        model = spec.model || null;
        majorIntxns = spec.majorIntxns;
        saveCallbackFn = spec.saveCallbackFn;
        hideCallbackFn = spec.hideCallbackFn;
        hasPrescriptionNote = spec.hasPrescriptionNote;

        // update the save button caption as necessary
        form.getButtonSet().updateButtonCaption('save', spec.overrideText || defaultOverrideText);

        $('.intxn-details', that.getContentElt()).empty();
        if (majorIntxns['drugDrug']) {
            $('.intxn-details', that.getContentElt()).append(
                el8.template.appchart.dialog.ordermed.ignoreIntxnReason.intxnDetails({
                    interactions: majorIntxns['drugDrug'],
                    type: 'drugDrug'
                })
            );
        }
        if (majorIntxns['drugAllergy']) {
            $('.intxn-details', that.getContentElt()).append(
                el8.template.appchart.dialog.ordermed.ignoreIntxnReason.intxnDetails({
                    interactions: majorIntxns['drugAllergy'],
                    type: 'drugAllergy'
                })
            );
        }
        if (hasPrescriptionNote) {
            $('.add-prescription-note', that.getContentElt()).show();
        } else {
            $('.add-prescription-note', that.getContentElt()).hide();
            form.setVal('addToPrescriptionNote', false);
        }
        if (model) {
            var pharmacyInstructions = model.getPharmacyInstructions();
            // Try to get previously-entered reason (e.g. when creating a Refill order).
            // Due to the way that ignoreIntxnReason is set up as a separate form and not tracked in
            // el8.appchart.dialog.ordermed.rxShared, getting the actual ignore reason is difficult.
            // It's provided by el8.ptdata.model.med.medOrderDetailsMgr but is only found on the
            // original prescription when an rxShared form is first initialized/pre-filled.
            var regex = new RegExp(el8.appchart.dialog.ordermed.confirmPharmacyNote.OVERRIDE_REASON_PREFIX + '([^\\.]+)');
            var matches = pharmacyInstructions.match(regex);
            if (matches) {
                form.setVal('ignoreIntxnReason', matches[1]);
            }
        }

        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function(spec) {
        // This causes the hideCallbackFn to also be called
        // when save is hit, but that's ok in this case.  Have to do for now
        // so that the "x" acts as desired
        super_hide.call(that);
        if (hideCallbackFn) { hideCallbackFn(); }
    };

    return that;
})();

